import {useEffect} from 'react';
import {useDocumentContext} from '@/components/document/context';
import {ModelAction} from '@/engine/types/model';

export const useDocumentMountEvent = (events?: ModelAction[]) => {
  const {ready} = useDocumentContext();

  useEffect(() => {
    if (!ready) return;

    events?.forEach(event => event());
  }, [events, ready]);
};
